import { Reveal } from "@/components/Reveal";
import { Eyebrow, Diamond } from "@/components/BrandGeometry";

export default function OciEngage() {
  return (
    <section
      id="oci-engage"
      className="relative overflow-hidden bg-navy text-white"
      data-testid="oci-engage"
    >
      <div className="absolute inset-0 grid-texture opacity-40" aria-hidden="true" />
      <div className="relative mx-auto max-w-7xl px-6 py-24 sm:px-10 sm:py-32 lg:px-16">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-5">
            <Reveal>
              <Eyebrow>Transparency</Eyebrow>
              <h2 className="mt-6 font-display text-3xl font-medium leading-tight tracking-tight text-white sm:text-4xl md:text-5xl">
                Clearer oversight through OCI Engage
              </h2>
            </Reveal>
          </div>
          <div className="lg:col-span-7">
            <Reveal delay={0.1}>
              <p className="text-lg leading-relaxed text-white/80">
                Amanah works with OCI Systems as its technology provider. OCI Engage supports
                structured campaign oversight, helping our charity partners maintain a clearer view
                of fundraising activity, performance and outcomes.
              </p>
              <div className="mt-8 inline-flex items-center gap-3 border border-white/15 px-5 py-4 text-sm text-white/60">
                <Diamond />
                Operational technology provided by OCI Systems.
              </div>
            </Reveal>
          </div>
        </div>
      </div>
    </section>
  );
}
